import BambooHRIcon from '@/assets/integrations/bamboohr.svg';
import ClockifyIcon from '@/assets/integrations/clockify.svg';
import GoogleIcon from '@/assets/integrations/google.svg';
import JiraIcon from '@/assets/integrations/jira.svg';
import NotionIcon from '@/assets/integrations/notion.svg';
import QuickbooksIcon from '@/assets/integrations/quickbooks.svg';
import SlackIcon from '@/assets/integrations/slack.svg';
import TempoIcon from '@/assets/integrations/tempo.svg';
import ZohoPeopleIcon from '@/assets/integrations/zoho_people.svg';

import {
  Integration,
  IntegrationDataType,
  IntegrationServices,
  IntegrationState,
} from '../../../common/types/integrations';

export const integrationsData: Integration[] = [
  {
    service: IntegrationServices.GOOGLE,
    dataTypes: [IntegrationDataType.TEAM_MEMBER],
    state: IntegrationState.NOT_CONNECTED,
  },
  {
    service: IntegrationServices.JIRA,
    dataTypes: [IntegrationDataType.TEAM_MEMBER, IntegrationDataType.PROJECT],
    state: IntegrationState.NOT_CONNECTED,
  },
  {
    service: IntegrationServices.TEMPO,
    dataTypes: [
      IntegrationDataType.PROJECT,
      IntegrationDataType.ASSIGNMENT,
      IntegrationDataType.TIME_LOG,
    ],
    state: IntegrationState.NOT_CONNECTED,
  },
  {
    service: IntegrationServices.CLOCKIFY,
    dataTypes: [
      IntegrationDataType.TEAM_MEMBER,
      IntegrationDataType.PROJECT,
      IntegrationDataType.TIME_LOG,
    ],
    state: IntegrationState.NOT_CONNECTED,
  },
  {
    service: IntegrationServices.QUICKBOOKS,
    dataTypes: [
      IntegrationDataType.TEAM_MEMBER,
      IntegrationDataType.CLIENT,
      IntegrationDataType.PROJECT,
      IntegrationDataType.FINANCE,
    ],
    state: IntegrationState.NOT_CONNECTED,
  },
];

const iconMap = {
  [IntegrationServices.GOOGLE]: GoogleIcon,
  [IntegrationServices.JIRA]: JiraIcon,
  [IntegrationServices.TEMPO]: TempoIcon,
  [IntegrationServices.QUICKBOOKS]: QuickbooksIcon,
  [IntegrationServices.SLACK]: SlackIcon,
  [IntegrationServices.NOTION]: NotionIcon,
  [IntegrationServices.CLOCKIFY]: ClockifyIcon,
  [IntegrationServices.ZOHO_PEOPLE]: ZohoPeopleIcon,
  [IntegrationServices.BAMBOOHR]: BambooHRIcon,
};

// TODO: Fill in the appropriate data.
export const guideMap = {
  [IntegrationServices.GOOGLE]: 'https://...',
  [IntegrationServices.JIRA]: 'https://...',
  [IntegrationServices.TEMPO]:
    'https://help.tempo.io/timesheets/latest/using-rest-api-integrations',
  [IntegrationServices.QUICKBOOKS]: 'https://...',
  [IntegrationServices.SLACK]: 'https://...',
  [IntegrationServices.NOTION]: 'https://...',
  [IntegrationServices.CLOCKIFY]:
    'https://clockify.me/help/administration/api-webhook-settings#api-keys',
  [IntegrationServices.BAMBOOHR]: 'https://...',
};

export const getServiceIcon = (service: IntegrationServices) => iconMap[service];
